import * as Yup from 'yup';

export const getProductsTest = (params: any = {}) =>
  Yup.array(
    Yup.object({
      product: Yup.object()
        .nullable()
        .required('Product required')
        .test('product-unique', 'Product must be unique', (value: any, context: any) => {
          const products = context?.from[context?.from?.length - 1]?.value?.products || [];
          if (!value?.id) {
            return true;
          }
          if (products.filter((product) => value.id === product?.product?.id)?.length > 1) {
            return false;
          }
          return true;
        }),
      count: Yup.number()
        .typeError('Count must be a number')
        .min(1, 'Count must be greater than 0')
        .required('Count required'),
      ...params,
    })
  );
